














  import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

  @Component({
    name:'CommonUpload'
  })
  export default class CommonUpload  extends Vue {
     @Prop({default: false}) isMultiple!: boolean
     @Prop() fileType: string|undefined
     @Prop() limit: number|undefined
     @Prop({default: 1}) num!: number
     private fileList:any=[]
     @Emit('onUpload')
     handleRemove(file:any) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList 
      
    }
    @Emit('onUpload')
     handleChange(file:any){
       const fileObj:any=file.file
       if(this.fileList.length>this.num){
         this.$message.warning('上传数量超过限制')
         this.handleRemove(fileObj)
         return false
       }
       if(this.fileType){
						const type:string = fileObj.name.substring(fileObj.name.lastIndexOf('.') + 1).toLowerCase()
						if (this.fileType.indexOf(type) === -1) {
              this.$message.warning('上传文件不支持'+type+'格式')  
              this.handleRemove(fileObj)       
              return false
            }   
        }
        	const fileSize = fileObj.size

					if(this.limit){
						if (fileSize>this.limit) {
              this.$message.warning( '文件大小超过限制')
              this.handleRemove(fileObj)   
              return false
						}
          }
          return this.fileList
     }
     handleBefore(file:any){
       this.fileList = [...this.fileList, file] 
       return false 
     }
  }
